import { V3CaptionGrey48 } from "../../ReusableStyledComponents/V3CaptionGrey48";
import { VerticalSpacing } from "../../VerticalSpacing";
import { V3Button } from "../../Button";
import { RightAlignPanel } from "../../ReusableStyledComponents/RightAlignPanel";
import { V3ButtonColor } from "../../Button/V3Button.types";
import { RoundedBoxCTA } from "../SharedComponents/RoundedBoxCTA";
import { SourceExistsFormTargets } from "./AddSource.utils";

interface AddSourceAlreadyExistsProps {
    onBackHandler: () => void;
    onCantFindArticles: () => void;
    onGoToSourceExistsForm: (target: SourceExistsFormTargets) => void;
    computedSourceSlug?: string;
}

export const AddSourceAlreadyExists = ({
    onBackHandler,
    onCantFindArticles,
    onGoToSourceExistsForm,
    computedSourceSlug
}: AddSourceAlreadyExistsProps) => {
    return (
        <>
            <VerticalSpacing bottom={28}>
                <V3CaptionGrey48>
                    It looks like we've already imported all articles with your byline from <strong>{computedSourceSlug || ""}</strong>. Are you
                    missing any pieces? Or is there anything else that's wrong?
                </V3CaptionGrey48>
            </VerticalSpacing>
            <RoundedBoxCTA text="Not all items have been imported" onClick={() => onGoToSourceExistsForm(SourceExistsFormTargets.ArticlesMissing)} />
            <RoundedBoxCTA
                text="The previously imported items look bad"
                onClick={() => onGoToSourceExistsForm(SourceExistsFormTargets.ImportLooksBad)}
            />
            <RoundedBoxCTA text="I can't find any previously imported items from this source" onClick={onCantFindArticles} />
            <RoundedBoxCTA text="It's something else" onClick={() => onGoToSourceExistsForm(SourceExistsFormTargets.SomethingElse)} />
            <VerticalSpacing top={24}>
                <RightAlignPanel>
                    <div>
                        <V3Button text="Back" autoWidth onClick={onBackHandler} color={V3ButtonColor.secondary} />
                    </div>
                </RightAlignPanel>
            </VerticalSpacing>
        </>
    );
};
